var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7721 13.3952V15.7702C17.773 15.9907 17.7278 16.209 17.6395 16.411C17.5512 16.613 17.4216 16.7943 17.2592 16.9434C17.0967 17.0924 16.9049 17.2059 16.696 17.2765C16.4872 17.3472 16.2659 17.3734 16.0463 17.3536C13.6102 17.0889 11.2701 16.2564 9.21419 14.9232C7.30138 13.7077 5.67966 12.086 4.46419 10.1732C3.12625 8.10786 2.29363 5.75644 2.03377 3.30941C2.01399 3.09048 2.04 2.86984 2.11017 2.66153C2.18033 2.45321 2.2931 2.26179 2.44129 2.09944C2.58949 1.93709 2.76986 1.80738 2.97094 1.71857C3.17201 1.62975 3.38937 1.58378 3.60919 1.58357H5.98419C6.36839 1.57979 6.74085 1.71584 7.03216 1.96637C7.32347 2.2169 7.51375 2.5648 7.56752 2.94524C7.66776 3.70529 7.85367 4.45157 8.12169 5.16982C8.2282 5.45318 8.25125 5.76113 8.18811 6.05719C8.12497 6.35324 7.97829 6.62499 7.76544 6.84024L6.76002 7.84566C7.887 9.82763 9.52805 11.4687 11.51 12.5957L12.5154 11.5902C12.7307 11.3774 13.0024 11.2307 13.2985 11.1676C13.5945 11.1044 13.9025 11.1275 14.1859 11.234C14.9041 11.502 15.6504 11.6879 16.4104 11.7882C16.795 11.8424 17.1462 12.0361 17.3973 12.3324C17.6483 12.6287 17.7817 13.007 17.7721 13.3952Z",
    stroke: "#07575B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a4f02464c8de4354077fb4bde2143ffb.svg";
export { ForwardRef as ReactComponent };